__turbopack_context__.v({
  "bar": "eJ1OVq_bar",
  "count": "eJ1OVq_count",
  "mine": "eJ1OVq_mine",
  "name": "eJ1OVq_name",
  "note": "eJ1OVq_note",
  "row": "eJ1OVq_row",
  "swatch": "eJ1OVq_swatch",
  "you": "eJ1OVq_you",
});
